<script setup lang="ts"></script>

<template>
  <NuxtLinkLocale
    to="/discussions"
    target="_blank"
    class="relative block overflow-hidden rounded-lg bg-gradient-to-br from-[#128C7E] to-[#25D366] p-4 text-white transition-all duration-500 ease-out hover:from-[#16A34A] hover:to-[#34D399]"
  >
    <NuxtImg
      src="/images/photostock/discussions.png"
      alt="Background"
      class="absolute bottom-[-20px] right-[-10px] z-0 object-contain transition-opacity duration-300"
      width="170"
      height="170"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <div class="relative z-10">
      <div class="mb-3 sm:hidden">
        <NuxtImg src="/images-backup/logos/logo-white.png" alt="Logo" width="70" height="26" />
      </div>

      <NuxtImg
        src="/images-backup/logos/logo-white.png"
        alt="Logo"
        class="mb-3 hidden sm:block"
        width="86"
        height="32"
      />

      <h3
        class="z-10 max-w-40 text-base font-bold leading-tight sm:mb-6 sm:max-w-full sm:text-xl xl:max-w-52"
      >
        {{ $t('widget.discussions.ask_specialist.title') }}
      </h3>

      <div class="mb-4 hidden items-center gap-2 sm:flex">
        <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.5 3.5 0 1 1 13 13.355z"
              fill="#128C7E"
            />
          </svg>
        </div>
        <span class="text-sm font-bold">{{ $t('widget.discussions.ask_specialist.cta') }}</span>
      </div>
    </div>
  </NuxtLinkLocale>
</template>
